import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createSelector } from '@ngrx/store';
import { svcDropdownsFeatureSelector } from '../svc-dropdowns-feature.selector';
import { ServiceGroupCategory } from '@quorum/models/xs-resource';
export interface ServiceGroupCategoriesState extends EntityState<ServiceGroupCategory> {}

export const serviceGroupCategoriesAdapter: EntityAdapter<ServiceGroupCategory> = createEntityAdapter<
  ServiceGroupCategory
>({
  selectId: (serviceGroupCategory: ServiceGroupCategory) => serviceGroupCategory.id,
});

export const initialState: ServiceGroupCategoriesState = serviceGroupCategoriesAdapter.getInitialState();

export const serviceGroupCategoriesSelector = createSelector(svcDropdownsFeatureSelector, (state: any) => {
  return state.serviceGroupCategories;
});

export const { selectIds, selectEntities, selectAll, selectTotal } = serviceGroupCategoriesAdapter.getSelectors(
  serviceGroupCategoriesSelector
);
